import { FC, useCallback, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// import { RepriseReimbursementResourcesLogo } from "../../assets";
import { AuthContext } from "../../context/authContext";
import { AuthenticatedRoutes, PublicRoutes, ManufacturerRoutes, PNLeadsRoutes, KAMLeadsRoutes, RepRoutes, TBMRoutes, DBMRoutes, } from "../../routes/AppRoutes";
import { parse } from "date-fns";

const HubSplashScreen: FC = (): JSX.Element => {
  const { isManufacturer, isUserAuthorized, userData, isRestoreCalled, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();


  const checkForAuthentication = useCallback(() => {
    console.log("Inside checkForAuthentication", { isUserAuthorized, userData, isManufacturer });
    if (isUserAuthorized && userData) {
      if (!userData.is_password_changed) {
        navigate('/users/createuser');
      } else if (isManufacturer) {
        if (userData.ref_type === "Manufacturer") {
          const indexRoute = ManufacturerRoutes.find((route) => route.isIndex);
          if (indexRoute) navigate(indexRoute.route);
        } 
        else if (userData.ref_type === "dbm") {
          const indexRoute = DBMRoutes.find((route) => route.isIndex);
          if (indexRoute) {
            if (indexRoute.route === "/dbm/:id") {            
              if(id === undefined) {
                if (userData)
                  navigate(`/dbm/${userData.id}`)
              } else {
                navigate(`/dbm/${id}`)
              }
            } else {
              navigate(indexRoute.route);
            }
          }
        }
        else if (userData.ref_type === "pn_lead") {
          const indexRoute = PNLeadsRoutes.find((route) => route.isIndex);
          console.log("Inside PN Lead checkForAuthentication",indexRoute , indexRoute?.route )

          if (indexRoute) {
            if (indexRoute.route === "/patientNavigatorLeads/:id") {            
              if(id === undefined) {
                if (userData)
                  navigate(`/patientNavigatorLeads/${userData.id}`)
              } else {
                navigate(`/patientNavigatorLeads/${id}`)
              }
            } else {
              navigate(indexRoute.route);
            }
          }
        }
        else if (userData.ref_type === "kam_lead") {
          const indexRoute = KAMLeadsRoutes.find((route) => route.isIndex);
                    console.log("Inside Kam Lead checkForAuthentication",indexRoute , indexRoute?.route )

          if (indexRoute) {
            if (indexRoute.route === "/kamleads/:id") {            
              if(id === undefined) {
                if (userData)
                  navigate(`/kamleads/${userData.id}`)
              } else {
                navigate(`/kamleads/${id}`)
              }
            } else {
              navigate(indexRoute.route);
            }
          }
        }
        else if ((["patient_navigator", "kam","tbm","rep"].includes(userData.ref_type.toLowerCase()))) {
          const indexRoute = RepRoutes.find((route) => route.isIndex);
                    console.log("Inside PN KAM checkForAuthentication",indexRoute , indexRoute?.route )

          if (indexRoute) {
            if (indexRoute.route === "/statistics/:id") {            
              if(id === undefined) {
                if (userData)
                  navigate(`/statistics/${userData.id}`)
              } else {
                navigate(`/statistics/${id}`)
              }
            } else {
              navigate(indexRoute.route);
            }
          }
        }
      } else {
        if (!userData.baa_viewed || (userData.baa_viewed_date && userData.baa_viewed_date.length > 0 && parse(userData.baa_viewed_date, "MM/dd/yyyy", new Date()) > new Date()))
          navigate("/pages/baa");
        else {
          const indexRoute = AuthenticatedRoutes.find((route) => route.isIndex);
          if (indexRoute) navigate(indexRoute.route);
        }
      }
    } else {
      const indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      const indexRoute = PublicRoutes.find((route) => route.isIndex);
      if (indexRoute) navigate(indexRoute.route);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkForAuthentication, isRestoreCalled]);

  return (
    <div className="container-fluid row justify-content-center align-items-center pt-4 pb-5" style={{ height: '100vh' }}>
      <div className="col-12 text-center">
        {/*<img height="110px" className="img-fluid mt-3" src={RepriseReimbursementResourcesLogo} alt="Site logo" />*/}

        <div className="mt-2">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubSplashScreen;
